var exports = {
  "b": "LexicalChannelTextareaContent.module__composerHost___eURiLT",
  "F": "LexicalChannelTextareaContent.module__composerEditable___eURiLT",
};

module.exports = exports;
